import React from "react";
import { Component } from "react";


export default class SingleSlider extends Component {

    state = {

        timerPercentage: 0,
        active: 0,
    }


    componentDidMount() {

        this.setTimer()
    }



    handleClick = (plus = 1) => {
        var active = this.state.active;

        active = active + plus

        if (active > this.props.children?.length - 1) {
            active = 0
        }

        if (active < 0) {
            active = this.props.children?.length - 1
        }


        this.setState({
            active: active
        }, () => {

            clearInterval(this.timer)
            this.setState({ timerPercentage: 0, notransition: true }, () => {
                setTimeout(() => {
                    this.setState({ notransition: false })
                    this.setTimer()
                }, 10);
            })
        });

    }




    setTimer = () => {

        let seconds = this.props.slideTimer / 5
        this.timer = setInterval(() => {
            if (this.state.timerPercentage < 100) {
                let timerPercentage = this.state.timerPercentage + 5
                this.setState({ timerPercentage })
            } else {
                this.handleClick()
            }
        }, seconds);

    }

    render() {
        var active = this.state.active;
        return (
            <div className="h-100 w-100 position-relative">
                <div className="h-100 w-100">
                    {Array.isArray(this.props.children) && this.props.children.map((child, index) => {
                        if (index == this.state.active)
                            return (
                                <div key={index} className="h-100 w-100">
                                    {child}
                                </div>
                            )
                    })}
                </div>
                <div className="w-100" style={{ position: 'absolute', bottom: 10 }}>
                    <div className="flexcb mx-3">
                        <div className=''>
                            <button name="previous " className="flexcc" style={{}} onClick={() => this.handleClick(-1)}>
                                <img width={40} src="/assets/icons/arrow.left.svg" />
                            </button>
                        </div>
                        <div style={{ justifyContent: 'right' }}>
                            {this.props.children.map((item, index) => {
                                return (
                                    <div key={index} className="circle" style={{ opacity: this.state.active == index ? 1 : 0.5 }}></div>
                                )
                            })}
                        </div>
                        <div>
                            <button name="next" className="flexcc" style={{}} onClick={() => this.handleClick()}>
                                <img width={40} src="/assets/icons/arrow.right.svg" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}